<div class="sender-partial-container">
  <div>
    <h1>Отправитель</h1>

    <div class="wrapperPersonTypeInn">
      <el-form-item prop="sender.senderType">
        <el-switch
          @change="handleChangeTypeOfPerson('Отправитель', $event)"
          :disabled="dataForm.thirdPerson.cargoTransportationCustomer === 'Отправитель'"
          v-model="dataForm.sender.senderType"
          inactive-text="Физ.лицо"
          active-text="Юр.лицо"
        />
      </el-form-item>
      <el-form-item style="flex: 1; width: 100%" v-if="dataForm.sender.senderType" label="ИНН отправителя" prop="sender.innSender">
        <InnAutocomplete
          :disabledCustom="dataForm.thirdPerson.cargoTransportationCustomer === 'Отправитель'"
          v-model:inn="dataForm.sender.innSender"
          @setOrganization="dataForm.sender.name = $event"
        />
      </el-form-item>
    </div>

    <el-form-item v-if="dataForm.sender.senderType" label="Наименование организации" prop="sender.name">
      <OrganizationAutocomplete
        :disabledCustom="dataForm.thirdPerson.cargoTransportationCustomer === 'Отправитель'"
        v-model:organization="dataForm.sender.name"
        @setInn="dataForm.sender.innSender = $event"
      />
    </el-form-item>

    <el-form-item class="personContactInfo">
      <el-form-item label="Телефон отправителя" prop="sender.phoneSender" class="sender-partial-container__phone">
        <el-input
          :disabled="dataForm.thirdPerson.cargoTransportationCustomer === 'Отправитель'"
          v-model="dataForm.sender.phoneSender"
          v-mask="PHONE_MASK"
          type="tel"
          :formatter="(value) => `${value}`.replace(/\(89/g, '9')"
          :placeholder="PHONE_PLACEHOLDER"
          @change="checkPhone"
        />
      </el-form-item>

      <el-form-item label="Эл. почта" prop="sender.emailSender" :required="dataForm.sender.senderType">
        <el-input :disabled="dataForm.thirdPerson.cargoTransportationCustomer === 'Отправитель'" type="email" autocomplete="email" v-model="dataForm.sender.emailSender" />
      </el-form-item>
    </el-form-item>

    <el-form-item label="ФИО отправителя" v-if="!dataForm.sender.senderType" class="personFio" prop="sender.fioSender">
      <FIOAutocomplete
        :disabled="dataForm.thirdPerson.cargoTransportationCustomer === 'Отправитель'"
        :onChangeSideEffect="() => ruleFormRef.validateField(['sender.fioSender'])"
        :disabledCustom="dataForm.thirdPerson.cargoTransportationCustomer === 'Отправитель'"
        v-model:fio="dataForm.sender.fioSender"
      />
    </el-form-item>

    <el-form-item label="Город отправки" prop="sender.cityFrom">
      <el-select
        value-key="id"
        style="width: 100%"
        v-model="dataForm.sender.cityFrom"
        placeholder="Выберите город"
        filterable
        v-cancel-read-only
        autocomplete="do-not-autofill"
        @change="hanlerCityFrom"
      >
        <el-option v-for="city in cities" :key="city.id" :label="city.title" :value="city" :disabled="disableIdenticalCity(city)" />
      </el-select>
    </el-form-item>

    <el-form-item prop="sender.senderZaborType">
      <el-radio-group :disabled="disabledZaborType" class="radioGroupButtonsDefault" v-model="dataForm.sender.senderZaborType" @change="handleSenderZaborType">
        <el-radio-button label="Забор груза" value="Забор груза" />
        <el-radio-button :disabled="dataForm.fetchedSuitableOffices.pickUp.length === 0" label="Сдать на склад" value="Сдать на склад" />
      </el-radio-group>
    </el-form-item>

    <el-form-item
      :error="formErrors.errorSenderAddressClick"
      style="flex: 1"
      :label="dataForm.sender.senderZaborType === 'Сдать на склад' ? 'Адрес склада' : 'Адрес забора груза'"
      prop="sender.addressCargoPickup"
    >
      <el-select
        value-key="id"
        filterable
        :disabled="disabledZaborType"
        v-cancel-read-only
        autocomplete="do-not-autofill"
        v-if="dataForm.sender.senderZaborType !== 'Забор груза'"
        style="width: 100%"
        v-model="dataForm.sender.addressCargoPickup"
        readonly
      >
        <el-option v-for="office in dataForm.fetchedSuitableOffices.pickUp" :key="office.id" :label="office.address" :value="office" />
      </el-select>

      <el-input
        :disabled="disabledZaborType"
        class="addressClick"
        @click="onClickAddressZabor"
        v-if="dataForm.sender.senderZaborType !== 'Сдать на склад' && dataForm.sender.senderZaborType !== ''"
        readonly
        :model-value="senderPickUp"
      />
    </el-form-item>
  </div>

  <el-dialog v-model="cargoInfoZaborForm.isOpen" title="Информация о заборе" class="dialog" center @close="cargoInfoZaborForm.handleClose">
    <el-form ref="cargoInfoZaborFormRef" :rules="cargoInfoZaborForm.rules" :model="cargoInfoZaborForm.model">
      <div class="addressWrapperCustom">
        <el-form-item style="flex: 1" label="Адрес забора" prop="addressCargoPickup" class="modalFormItem">
          <AddressAutocompleteSelectOnly
            :onCommandClick="() => cargoInfoZaborFormRef.validateField(['addressCargoPickup', 'detailsPickup'])"
            :modalState="cargoInfoZaborForm.isOpen"
            v-model:address="cargoInfoZaborForm.model.addressCargoPickup"
            :city="dataForm.sender.cityFrom"
          />
        </el-form-item>
        <el-form-item style="flex: 1" label="Уточнение адреса" prop="detailsPickup" class="modalFormItem">
          <el-input v-model="cargoInfoZaborForm.model.detailsPickup" placeholder="Уточнение" @input="() => cargoInfoZaborFormRef.validateField(['addressCargoPickup', 'detailsPickup'])" @blur="cargoInfoZaborForm.model.detailsPickup=cargoInfoZaborForm.model.detailsPickup.trim()" />
        </el-form-item>
      </div>
      <div class="wrapperTime">
        <el-form-item style="flex: 1; width: 100%" label="Дата забора" prop="pickupDate">
          <el-date-picker
            style="width: 100%"
            v-model="cargoInfoZaborForm.model.pickupDate"
            @change="handleDateChange"
            type="date"
            placeholder="Выберите дату"
            format="DD/MM/YYYY"
            :disabled-date="datePickerOptions"
            :clearable="false"
          />
        </el-form-item>
        <el-form-item style="flex: 1; width: 100%" label="Доступное время забора" prop="cargoTimePickup">
          <el-select
            value-key="intervalTitle"
            :disabled="!Boolean(cargoInfoZaborForm.model.pickupDate)"
            style="width: 100%"
            v-model="cargoInfoZaborForm.model.cargoTimePickup"
            placeholder="Время забора"
            v-cancel-read-only
            autocomplete="do-not-autofill"
          >
            <el-option v-for="(time, index) in availableTimeIntervals" :key="index" :label="time.intervalTitle" :value="time" />
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="Комментарий">
        <el-input v-model="cargoInfoZaborForm.model.comment" type="textarea" />
      </el-form-item>

      <div style="display: flex; flex-direction: column; gap: 10px">
        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
          <el-form-item prop="powerOfAttorney">
            <el-switch v-model="cargoInfoZaborForm.model.powerOfAttorney" active-text="Доверенность" @change="handlePowerOfAttorneyChange" />
          </el-form-item>
          <el-form-item style="width: 50%" label="Тип доверенности" prop="typePowerOfAttorney" :required="cargoInfoZaborForm.model.powerOfAttorney">
            <el-select style="flex: 1" v-model="cargoInfoZaborForm.model.typePowerOfAttorney" :disabled="!cargoInfoZaborForm.model.powerOfAttorney" placeholder="Выберите вариант">
              <el-option v-for="option in optionsTypePowerOfAttorney" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>
          </el-form-item>
        </div>
        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
          <el-form-item prop="dataForTheDriver">
            <el-switch v-model="cargoInfoZaborForm.model.dataForTheDriver" active-text="Нужны данные на водителя" @change="(value) => toggleResetFields(value, ['sendTo'])" />
          </el-form-item>
          <el-form-item style="width: 50%" label="Отправить на" prop="sendTo" :required="cargoInfoZaborForm.model.dataForTheDriver">
            <el-select style="flex: 1; min-width: 150px" v-model="cargoInfoZaborForm.model.sendTo" placeholder="Выберите вариант" :disabled="!cargoInfoZaborForm.model.dataForTheDriver">
              <el-option v-for="communication in communications" :key="communication.value" :label="communication.label" :value="communication.value" />
            </el-select>
          </el-form-item>
        </div>
      </div>

      <el-form-item prop="whoPaysZabor" label="Плательщик за забор груза">
        <el-radio-group @change="handleChangePayerModalForm('cargoPickup', $event)" class="radioGroupButtonsDefault" v-model="cargoInfoZaborForm.model.whoPaysZabor">
          <el-radio-button label="Отправитель" value="Отправитель" />
          <el-radio-button label="Получатель" value="Получатель" />
          <el-radio-button :disabled="!dataForm.getThirdPersonAvailable" label="Третье лицо" value="Третье лицо" />
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="typeOfPaymentZabor" label="Способ оплаты">
        <el-radio-group class="radioGroupButtonsDefault" v-model="cargoInfoZaborForm.model.typeOfPaymentZabor">
          <el-radio-button label="Наличные" value="Наличные" />
          <el-radio-button :disabled="checkDisabledAccount(cargoInfoZaborForm.model.whoPaysZabor)" label="Расчётный счет юр. лица" value="Расчётный счет юр. лица" />
        </el-radio-group>
      </el-form-item>
      <div style="width: 100%; display: flex; justify-content: center">
        <el-button class="button_send" type="primary" @click="cargoInfoZaborForm.submitForm(cargoInfoZaborFormRef)"> Сохранить </el-button>
      </div>
    </el-form>
  </el-dialog>

  <div class="container_button">
    <el-form-item>
      <!-- <router-link to="/calculator" class="button-link">
        <el-button 
          class="button_shadow"
          type="primary"
        > 
          Калькулятор
        </el-button>
      </router-link> -->
    </el-form-item>
    <el-form-item>
      <!-- <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-next')"
        >
        Далее
      </el-button> -->
    </el-form-item>
  </div>
</div>
